import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import { Link, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import loginimg from '../Assets/Images/image.png'
import logo from '../Assets/Images/Caduceus 512x512.gif'
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { toast } from 'react-toastify'
import { BASE_URL, LOGIN } from '../API';
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import Loader from "../components/Loader";

function Login() {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const togglePasswordVisibility = () => { setShowPassword(!showPassword) };

  useEffect(() => {
    const savedEmail = localStorage.getItem('email');
    const savedPassword = localStorage.getItem('password');
    if (savedEmail && savedPassword) {
      setValue('email', savedEmail);
      setValue('password', savedPassword);
      setRememberMe(true);
    }
  }, [setValue]);

  const onSubmit = async (data) => {
    setIsLoading(true);

    if (rememberMe) {
      localStorage.setItem('email', data.email);
      localStorage.setItem('password', data.password);
    } else {
      localStorage.removeItem('email');
      localStorage.removeItem('password');
    }
    data.language = "ENGLISH"
    try {
      const response = await axios.post(BASE_URL + LOGIN, data);
      if (response.status === 200) {
        toast.success(response.data.message)
        navigate('/otp', {
          state: { data: data?.email },
          replace: true
        })
      }
    } catch (error) {
      let err = ''
      if (error.response.data.error_message) { err = error.response.data.error_message; }
      else {
        err = error.response.data.error_description;
      }
      toast.error(err)
    } finally {
      setIsLoading(false);

    }
  }

  return (
    <>
      <Loader isLoading={isLoading} />

      <section className="login-section">
        <div className="container-fluid g-0">
          {/* <Header /> */}
          <Row className='row-min-h'>
            <Col lg={6} className='img-n'>
              <div className="upper-fig-main-login">
                <figure className='login-img-main'>
                  <img src={loginimg} alt="" className='img-fluid' />
                </figure>
              </div>
            </Col>
            <Col lg={6}>
              <div className="inner-login-mian">
                <div className="loginupper-right">
                  <figure className='creden_page_logo'>
                    <img src={logo} alt="" className='img-fluid' />
                  </figure>
                  <h2>Login</h2>
                  <p className='auth_page_sub_heading'>Login to continue your personalized healthcare journey!</p>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md={12}>
                        <Form.Group controlId="formGridEmail" className='comn-class-inputs'>
                          <Form.Label>email</Form.Label>
                          <Form.Control type="email" placeholder="Enter Your Email"
                            {...register("email", {
                              required: 'Please enter email.',
                              pattern: {
                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$|^[a-zA-Z0-9._-]{3,16}$/,
                                message: "Please enter valid email."
                              }
                            })}
                          />
                          {errors.email && <span className='error'>{errors.email.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group controlId="formGridPassword" className='comn-class-inputs'>
                          <Form.Label>Password</Form.Label>
                          <div className="cstPassGroup">
                            <Form.Control
                              type={showPassword ? 'text' : 'password'}
                              placeholder="Enter Your Password"
                              {...register("password", { required: 'Please enter password.', })} />

                            <div onClick={togglePasswordVisibility} className="eyeToggleBtn">
                              {showPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                            </div>
                          </div>
                          {errors.password && <span className='error'>{errors.password.message}</span>}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="login_remeber_row d-flex">
                      <div className="">
                        <Form.Group className="custom-checkbox remember_me_checkbox">
                          <Form.Check
                            type="checkbox"
                            className="ps-0"
                            label="Remember Me"
                            id="checkbox1"
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                          />
                          {/* <label for="checkbox1"></label> */}
                        </Form.Group>
                      </div>
                      <Link className='forgot-link' to={'/forgotpassword'}>Forgot Password?</Link>
                    </div>
                    <Button className='login-btn' type="submit">
                      Login
                    </Button>
                  </Form>
                  {/* <div className="auth-bottom-link-sec">
                                        <p>Don’t have an account? <Link to="/registration">Sign Up</Link></p>
                                    </div> */}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  )
}

export default Login